import React from "react";

const MaxWidth = ({ children }) => {
  return <div className="max-w-[2000px] m-auto">{children}</div>;
};

export default MaxWidth;
